import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api_Url = process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";


export const getNotificationListThunk = createAsyncThunk(
    "get-notification-list",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${api_Url}/api/notification-list`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        } catch (error) {
            console.log("error:", error);
            return rejectWithValue(error?.response?.data || "Unknown error");
        }
    }
);

export const deleteNotificationThunk = createAsyncThunk(
    "delete-notification",
    async ({ token,notificationId }, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${api_Url}/api/notification-delete/${notificationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        } catch (error) {
            console.log("error:", error);
            return rejectWithValue(error?.response?.data || "Unknown error");
        }
    }
);
    export const markAsReadThunk = createAsyncThunk(
    "mark-as-read-notification",
    async ({ token, data }) => {

        try {
            const response = await axios.post(`${api_Url}/api/mark-as-read-notification`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        }
        catch (error) {
            console.log("error:", error)
        }
    });
